import {
  DateField,
  useRecordContext,
  RecordContextProvider,
  NumberField,
  TabbedShowLayout,
  useTranslate,
  ReferenceField,
  TextField,
} from "react-admin";
import Box from "@mui/material/Box";

const KindExpandList = () => {
  const record = useRecordContext();
  const t = useTranslate();
  return (
    <Box
      sx={{
        m: 5,
        backgroundClip: "padding-box",
        borderRadius: "4px",
      }}
    >
      <Box
        sx={{
          overflow: "hidden",
          borderRadius: "8px",
          borderTopLeftRadius: 0,
          boxShadow: (theme) => {
            return theme.components.MuiPaper ? theme.components.MuiPaper
              .styleOverrides.elevation1.boxShadow : undefined;
          },
          bgcolor: "background.paper",
        }}
      >
        <Box
          component="table"
          sx={{
            width: "100%",
            // bgcolor: "rgba(0,0,0,.04)",
            // fontSize: "smaller",
            borderCollapse: "collapse",
            "& th, td": {
              padding: "6px 8px",
              border: "1px solid #dddddd",
            },
          }}
        >
          <thead>
            <tr>
              <th>{t("mine.label.coa")}</th>
              <th>{t("mine.label.coa_name")}</th>
            </tr>
          </thead>
          <RecordContextProvider value={record}>
            <tbody>
              <tr>
                <td>
                  <ReferenceField
                    source="sales_goods_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="code"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
                <td>
                  <ReferenceField
                    source="sales_goods_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="name"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
              </tr>
              <tr>
                <td>
                  <ReferenceField
                    source="sales_return_good_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="code"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
                <td>
                  <ReferenceField
                    source="sales_return_good_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="name"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
              </tr>
              <tr>
                <td>
                  <ReferenceField
                    source="sales_return_broke_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="code"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
                <td>
                  <ReferenceField
                    source="sales_return_broke_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="name"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
              </tr>
              <tr>
                <td>
                  <ReferenceField
                    source="sales_return_complain_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="code"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
                <td>
                  <ReferenceField
                    source="sales_return_complain_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="name"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
              </tr>
              <tr>
                <td>
                  <ReferenceField
                    source="sales_discount_good_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="code"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
                <td>
                  <ReferenceField
                    source="sales_discount_good_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="name"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
              </tr>
              <tr>
                <td>
                  <ReferenceField
                    source="sales_discount_cash_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="code"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
                <td>
                  <ReferenceField
                    source="sales_discount_cash_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="name"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
              </tr>
              <tr>
                <td>
                  <ReferenceField
                    source="sales_discount_complain_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="code"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
                <td>
                  <ReferenceField
                    source="sales_discount_complain_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="name"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
              </tr>
              <tr>
                <td>
                  <ReferenceField
                    source="sales_discount_pick_by_self_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="code"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
                <td>
                  <ReferenceField
                    source="sales_discount_pick_by_self_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="name"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
              </tr>
              <tr>
                <td>
                  <ReferenceField
                    source="sales_discount_special_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="code"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
                <td>
                  <ReferenceField
                    source="sales_discount_special_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="name"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
              </tr>
              <tr>
                <td>
                  <ReferenceField
                    source="cost_of_goods_sold_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="code"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
                <td>
                  <ReferenceField
                    source="cost_of_goods_sold_id"
                    reference="coa"
                    emptyText="-"
                  >
                    <TextField
                      source="name"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </ReferenceField>
                </td>
              </tr>
            </tbody>
          </RecordContextProvider>
        </Box>
      </Box>
    </Box>
  );
};

export default KindExpandList;
